import React, { useContext } from "react"
import { LoadingContext } from "./loading.context"

// Use environment variable for API URL
// Falls back to localhost if not set
export const DefaultURl = process.env.REACT_APP_API_URL || 'https://dev.nexus.genericentity.devlop.systems/api/v1/'

// Available URLs for reference:
// SERVIDOR DEVLOP: http://192.168.20.5:5101/v1/
// LOCALHOST: http://localhost:5271/v1/
// SERVIDOR PRODUÇÃO NAIP: http://psl.webtrans.devlop.systems:6817/v1/
// PRODUCTION: https://dev.nexus.genericentity.devlop.systems/v1/

export function DefaultFunctionURL() {
    const ctx = useContext(LoadingContext)
    return ctx.DEFAULTURL ? ctx.DEFAULTURL : DefaultURl
}